import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export type DashboardPeriod = "THIS_MONTH" | "LAST_MONTH" | "LAST_3M" | "LAST_12M" | "YTD";

export type AlertSeverity = "critical" | "warning" | "info";

export interface DashboardAlert {
  severity: AlertSeverity;
  code: string;
  message: string;
  link: string;
}

export interface DashboardData {
  account: { revenueModel: string | null; status: string | null; currency: string };
  kpis: {
    collectedFees: { value: string; count: number; delta: string; deltaPct: number | null };
    avgPerTxn: { value: string; deltaPct: number | null };
    platformCharge: { estimate: string; nextInvoiceDate: string | null };
    netIncome: { value: string };
    overdue: { count: number; amount: string };
  };
  revenueTrend: Array<{ month: string; collected: string; platformCost: string }>;
  policyBreakdown: Array<{ scope: "DEFAULT" | "NAMED"; customers: number; pct: number }>;
  invoices: Array<{ no: string; period: string; amount: string; status: string }>;
  topCustomers: Array<{ rank: number; name: string; amount: string }>;
  alerts: DashboardAlert[];
  activity: Array<{ type: string; title: string; at: string }>;
}

// Two independent filters, AND-combined server-side:
//   month            — single month, "YYYY-MM"
//   startDate/endDate — day-level range, "YYYY-MM-DD" (capped at 3 months)
export interface DashboardFilters { month?: string; startDate?: string; endDate?: string; }

// Single tenant-scoped aggregate powering the dashboard. The server reads the tenant
// from the JWT — the UI never sends a tenantId (UI-SPEC §3). Empty filters → rolling
// LAST_3M window (so the dashboard isn't blank at the start of each month).
export const getMy = (filters: DashboardFilters): Promise<DashboardData> => {
  const params: Record<string, string> = {};
  if (filters.month) params.month = filters.month;
  if (filters.startDate) params.startDate = filters.startDate;
  if (filters.endDate) params.endDate = filters.endDate;
  return httpRequest.get("/bil/my/dashboard", params);
};
